import { isPlainObject } from 'remeda';

export function isPropertyPresent(obj: Object, property: string): boolean {
  return Object.hasOwn(obj, property);
}

export function arePropertiesPresent(obj: Object, properties: Array<string>): boolean {
  return properties.every(property => isPropertyPresent(obj, property));
}

export function isDynamicFooterField(
  candidate: unknown,
): candidate is { field: string; name: string } {
  return isPlainObject(candidate) && arePropertiesPresent(candidate, ['field', 'content']);
}
